import React from 'react';
import 'antd/dist/antd.css';


const titleBar = props => {
    return (
        <div className="mstr-title-bar">
            <img
                className="mstr-icon"
                alt="mstr icon"
                src={require('../../assets/Icons/logo.svg').default}
            />
            <div className="mstr-title-font">Strategy One Silent Install File Generator</div>
        </div>
    );
}

export default titleBar;